/**
 * GET `admin/clients/:id/ledger` — остаток на счёте клиники и журнал
 * операций постранично (бэк отдаёт по 25, максимум 100).
 *
 * `autopayEnabled` в ответе читаем, но на экран не выводим:
 * автосписание пока не запущено, и показать флаг значило бы пообещать
 * автоматику, которой нет. Держим в домене, чтобы не переделывать
 * разбор, когда её включат.
 */

import {http} from '@services/utils';

import {asNum, asObj, toLedgerEntry} from '../toLedger';
import type {Ledger} from '../types';

export const getLedger = async (
  clinicId: string,
  page: number,
  pageSize: number,
): Promise<Ledger> => {
  const r = asObj(
    await http(`admin/clients/${encodeURIComponent(clinicId)}/ledger`, {
      params: {page, pageSize},
      skipCaseConversion: true,
    }),
  );
  return {
    balanceTiyin: asNum(r.balanceTiyin),
    autopayEnabled: r.autopayEnabled === true,
    list: (Array.isArray(r.list) ? r.list : []).map(toLedgerEntry),
    currentPage: asNum(r.currentPage) || page,
    pageSize: asNum(r.pageSize) || pageSize,
    totalCount: asNum(r.totalCount),
  };
};
